export enum HideTypeEnum {
  NONE,
  TEXT
}
